import axios from 'axios'

const state = () => ({
    videos: []
})

const getters = {
    videos(state) {
        return state.videos
    }
}

const mutations = {
    SET_VIDEOS(state, payload){
        state.videos = payload
    }
}

const actions = {
    getVideos({commit}){
        // let myPayload = Object.assign({}, payload)
        // myPayload.page -= 1
        axios.get('https://api.geomalaka.uz/api/main/video/')
            .then((res)=>{
                commit("SET_VIDEOS", res.data)
            })
            .catch((error)=>{
                console.log(error)
            })
    },
}

export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}

